import { useCallback, type Dispatch, type MutableRefObject, type SetStateAction } from "react";
import type { Lead } from "@/types/lead";

export function useCommitTranscriptToCurrentLead(
  setTranscript: Dispatch<SetStateAction<string>>,
  setCurrentLead: Dispatch<SetStateAction<Lead | null>>,
  setLeads: Dispatch<SetStateAction<Lead[]>>,
  transcriptRef: MutableRefObject<string>,
  currentLeadRef: MutableRefObject<Lead | null>
) {
  return useCallback(
    (next: string) => {
      setTranscript(next);
      transcriptRef.current = next;
      const lead = currentLeadRef.current;
      if (!lead) return;
      const updated = { ...lead, transcript: next, lastUpdated: Date.now() };
      currentLeadRef.current = updated;
      setCurrentLead(updated);
      setLeads((prev) => prev.map((l) => (l.id === updated.id ? updated : l)));
    },
    [setTranscript, setCurrentLead, setLeads, transcriptRef, currentLeadRef]
  );
}
